export default {
      id: "icon-fantome-usage",
      viewBox: "0 0 101.4 127.3",
      url: __webpack_public_path__ + "icons.svg#icon-fantome",
      toString: function () {
        return this.url;
      }
    }